import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "../../assets/icons/edit-icon.svg";
import ShareIcon from "../../assets/icons/share-icon.svg";
import ArchiveIcon from "../../assets/icons/archive-icon.svg";
type Props = {
  row: any;
  setIsShowCreateLeadSection: any;
  setCreateLeadCaptureInitialValues: any;
  setIsShowConfirmationPopup: any;
  setArchive?:any;
  isEmailConfigured?: boolean;
};

const CustomActionsDropdown: React.FC<Props> = ({
  row,
  setIsShowCreateLeadSection,
  setCreateLeadCaptureInitialValues,
  setIsShowConfirmationPopup,
  setArchive,
  isEmailConfigured = false,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();
    setIsShowCreateLeadSection(true);
    setCreateLeadCaptureInitialValues(row?.data);
  };
  const handleArchive = () => {
    handleClose();
    if (setArchive) {
      setArchive(row.id);
    }
  };

  const handleShare = () => {
    handleClose();
    setIsShowConfirmationPopup(true);
    setCreateLeadCaptureInitialValues(row?.data);
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
            minWidth: 160,
          },
        }}
      >
        <MenuItem onClick={handleEdit}>
          <ListItemIcon>
            <img src={EditIcon} alt="Edit Icon" />
          </ListItemIcon>
          <ListItemText primary="Edit" />
        </MenuItem>
        <MenuItem onClick={handleShare}>
          <ListItemIcon>
            <img src={ShareIcon} alt="Share Icon" />
          </ListItemIcon>
          <ListItemText primary="Share" />
        </MenuItem>
        <MenuItem onClick={handleArchive}>
          <ListItemIcon>
            <img src={ArchiveIcon} alt="Archive Icon" />
          </ListItemIcon>
          <ListItemText primary="Archive" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default CustomActionsDropdown;
